import systemApi from '@/pages/index/api/system'
import { listWidth } from '@/config/dictionary/config'
import { RegExpRule } from '@/config/utils'
import TotalComplexList from '@/class/TotalComplexList'
import { serviceProviderSelect } from '@/pages/index/select/complex'

export class ServiceProvider extends TotalComplexList {
  buildItem(postData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      systemApi.serviceProviderBuild.require(postData).then(() => {
        this.$reloadData({
          force: true,
          change: true
        })!.finally(() => {
          resolve({ status: 'success' })
        })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  changeItem(postData: Record<string, unknown>, originData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      systemApi.serviceProviderChange.require(postData).then(() => {
        this.$reloadData({
          force: true,
          change: true
        })!.finally(() => {
          resolve({ status: 'success' })
        })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  deleteItem() {
    return new Promise((resolve, reject) => {
      systemApi.serviceProviderDelete.require(this.$module.choice!.getId() as string[]).then(() => {
        this.$module.choice!.$reset()
        this.$reloadData({
          force: true,
          change: true
        })!.finally(() => {
          resolve({ status: 'success' })
        })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
}

const serviceProvider = new ServiceProvider({
  name: '服务商',
  prop: 'serviceProvider',
  select: serviceProviderSelect,
  module: {
    pagination: true,
    choice: {},
    search: {
      module: {
        dictionary: {
          layout: {
            default: {
              grid: 6,
              label: 8,
              content: 16
            }
          },
          list: [
            {
              prop: 'serviceName',
              name: '服务商名称',
              originProp: 'serviceName',
              originFrom: 'list',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
          ]
        }
      },
      menu: {
        list: []
      },
    },
    dictionary: {
      layout: {
        default: {
          grid: 24,
          label: 7,
          content: 17
        }
      },
      option: {},
      propData: {
        id: 'id'
      },
      list: [
        {
          prop: 'id',
          name: 'ID',
          originProp: 'id',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'serviceName',
          name: '服务商名称',
          originProp: 'serviceName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(12)
            },
            edit: {
              type: 'input',
              required: true,
              option: {
                maxLength: 50
              }
            },
            build: {
              $target: 'edit'
            },
            change: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'contactName',
          name: '联系人',
          originProp: 'contactName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            },
            edit: {
              type: 'input',
              required: true,
              option: {
                maxLength: 20
              }
            },
            build: {
              $target: 'edit'
            },
            change: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'contactPhone',
          name: '联系人电话',
          originProp: 'contactPhone',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.phone
            },
            edit: {
              type: 'input',
              required: true,
              option: {
                maxLength: 20
              },
              rules: [
                {
                  validator (rule: any, val?: string) {
                    if (val) {
                      if (RegExpRule.mobilePhone.test(val) || RegExpRule.linePhone.test(val)) {
                        return Promise.resolve()
                      } else {
                        return Promise.reject()
                      }
                    }
                    return Promise.reject()
                  },
                  message: '请输入正确的联系方式'
                }
              ]
            },
            build: {
              $target: 'edit'
            },
            change: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'enableFlag',
          name: '状态',
          originProp: 'enableFlag',
          originFrom: 'list',
          format(value) {
            return value === 1
          },
          show(value) {
            return value ? '启用' : '禁用'
          },
          post(value) {
            return value ? 1 : 0
          },
          mod: {
            list: {
              width: listWidth.getWidth(2)
            },
            edit: {
              type: 'switch',
              required: true,
              value: {
                default: true
              },
              local: {
                target: {
                  props: {
                    checkedChildren: '启用',
                    unCheckedChildren: '禁用'
                  }
                }
              }
            },
            build: {
              $target: 'edit'
            },
            change: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'remark',
          name: '备注',
          originProp: 'remark',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'createdName',
          name: '创建人',
          originProp: 'createdName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'createdBy',
          name: '创建人',
          originProp: 'createdBy',
          originFrom: 'list',
        },
        {
          prop: 'createdTime',
          name: '创建时间',
          originProp: 'createdTime',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.time
            }
          }
        },
        {
          prop: 'updatedBy',
          name: '最后更新人',
          originProp: 'updatedBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'updatedTime',
          name: '更新时间',
          originProp: 'updatedTime',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'menu',
          name: '操作',
          originProp: 'menu',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(2)
            }
          }
        },
      ]
    }
  }
})

export default serviceProvider
